import { ToastController } from 'ionic-angular';
import { APP_INITIALIZER, Injectable,InjectionToken } from '@angular/core';

import { HttpClientService } from './http-client.service';
// import { Logger } from '../logging';

@Injectable()
export class HttpErrorNotificationService {
  constructor(
    private httpClientService: HttpClientService,
    private toastController: ToastController
    // private logger: Logger,
  ) {
  }

  public init() {
    this.httpClientService.getErrors().subscribe(err => {

      // log with the logger
      // this.logger.error(err);

      // show toast for network errors
      // also show for server errors?
      if (err.type === 'network') {
        const toast = this.toastController.create({
          message: err.message,
          duration: 5000,
          position: 'bottom',
        });

        toast.present();
      }
    });
  }
}

  export function httpErrorServiceFactory(httpErrorService: HttpErrorNotificationService): Function {
    return () => {
      httpErrorService.init();
    };
  }

  /**
   * DeployInitializer attaches to the angular bootstrap
   * process.
   */
  export const HttpErrorServiceInitializer = {
    provide: APP_INITIALIZER,
    useFactory: httpErrorServiceFactory,
    deps: [ HttpErrorNotificationService ],
    multi: true,
  };
